import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { FilterFieldGroup, HotelResult, Location, SortingFieldGroup } from "../../../Models";
import HotelSearchCriteria from "../../../states/HotelSearchCriteria";
import LoadingIndicator from "../../common/LoadingIndicator";
import HotelResultComponent from "../../desktop/hotelsearch/HotelResultComponent";
import HotelSearchFormCard from "./HotelSearchFormCard";
import HotelResultDesktopFilter from "./HotelResultDesktopFilter";
import LightBox from "../../common/lightbox/LightBox";

interface Attrs {    
    locations : Location[],
    messageProvider: MessageProvider;
    searchCriteria: HotelSearchCriteria;
    filterFieldGroup?: FilterFieldGroup;
    sortingFieldGroup?: SortingFieldGroup;
    hotelResults?: HotelResult[];
    isLoadingMore: boolean;
    onSearch: (searchCriteria:HotelSearchCriteria) => void;
    onHotelResultSelected: (hotelResult: HotelResult) => void;
    onLoadMore: () => void;
}

interface HotelPhotoDialogShown {
    photoUrls:string[]
}
type HotelPhotosDialogState = 'hidden' | HotelPhotoDialogShown;

function HotelSearchPage(): m.Component<Attrs> {

    let hotelPhotoDialogState:HotelPhotosDialogState = 'hidden';
    let hotelResultsState: HotelResult[]|undefined = undefined;
    let observer: IntersectionObserver | null = null;

    function setupLoadMoreObserver(vnode: m.VnodeDOM<Attrs>) {
    
            const sentinel = vnode.dom.querySelector(".hotel-list-sentinel");
    
            if (!sentinel) {
                console.log("hotel-list-sentinel not found");
                return;
            }
    
            observer?.disconnect();
    
            observer = new IntersectionObserver(
                entries => {
    
                    const entry = entries[0];
    
                    if (!entry.isIntersecting) {
                        return;
                    }
    
                    console.log("Near hotel list bottom");
    
                    if (vnode.attrs.isLoadingMore) {
                        return;
                    }
    
                    vnode.attrs.onLoadMore();
                },
                {
                    root: null,
                    rootMargin: "0px 0px 500px 0px",
                    threshold: 0
                }
            );
    
            observer.observe(sentinel);
        }

    return {
        oncreate(vnode) {
            let btn = document.getElementById("scrollToTop");

            if(btn != null) {
                window.addEventListener("scroll", () => {
                btn.style.display = window.scrollY > 200 ? "block" : "none";
                });

                btn.addEventListener("click", () => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                });
            }

            setupLoadMoreObserver(vnode);
        },
        onremove(vnode) {
            if (observer) {
                observer.disconnect();
                observer = null;
            }
        },
        onupdate(vnode) {
            setupLoadMoreObserver(vnode);
        },
        view(vnode) {    
            const {locations, messageProvider, searchCriteria, filterFieldGroup, sortingFieldGroup, hotelResults, isLoadingMore, onHotelResultSelected, onSearch} = vnode.attrs;    
            hotelResultsState = hotelResults;


            return m("div.mx-3", [ 
                m("div.row", 
                    m("div.col", [
                        m(HotelSearchFormCard, {
                            messageProvider : messageProvider,
                            locations: locations,
                            searchCriteria: searchCriteria,
                            onSearch: function(searchCriteria){
                                onSearch(searchCriteria);
                            }
                        }),   
                        
                        (filterFieldGroup && sortingFieldGroup)?
                        m("div.row", [
                            m("div.col-md-4", 
                                m("div.card mt-3 rounded-25 shadow", 
                                    m("div.card-body", 
                                        m(HotelResultDesktopFilter, {
                                            messageProvider : messageProvider,
                                            filterFieldGroup: filterFieldGroup,
                                            sortingFieldGroup: sortingFieldGroup,
                                            onFilterPriceRangeSelected: function(value){     
                                                hotelResultsState = undefined;
                                                let newSearchCriteria = (value)? searchCriteria.withFilterByPriceRange(value) : searchCriteria.withoutFilterByPriceRange();
                                                onSearch(newSearchCriteria);   
                                            },
                                            onSortByPriceSelected: function(priceSortValue) {      
                                                hotelResultsState = undefined;                                          
                                                let newSearchCriteria = (priceSortValue)? searchCriteria.withSortByPrice(priceSortValue) : searchCriteria.withoutSortByPrice();
                                                onSearch(newSearchCriteria);    
                                            }
                                        })                                    
                                    )
                                )
                            ),
                            m("div.col-md-8", 
                                (hotelResultsState != undefined && hotelResultsState.length == 0)?
                                m("div.my-3 alert alert-warning", messageProvider.get("no_hotels_try_other_dates")) : null,

                                (hotelResultsState)?        
                                [
                                    hotelResultsState.map(function (hotelResult) {
                                        return m("div.my-3", {
                                            class: "clickable"
                                        },
                                            m(HotelResultComponent, {
                                                hotelResult: hotelResult,
                                                messageProvider: messageProvider,
                                                onViewImageSelected: (imageUrls) => {
                                                    console.log("image urls", imageUrls);
                                                    hotelPhotoDialogState = { photoUrls: imageUrls }
                                                },
                                                onHotelResultSelected: function (hotelResult) {
                                                    onHotelResultSelected(hotelResult);
                                                }
                                            }) 
                                        )
                                    }),
                                    (isLoadingMore)? 
                                    m("div", {class: "d-flex justify-content-center"}, 
                                        m("div", {class: "spinner-border text-secondary", role: "status"}, [
                                            m("span", {class: "sr-only"}, "Loading...")
                                        ])
                                    ):null,
                                    m(".hotel-list-sentinel")
                                ] : 
                                m("div.p-5", 
                                    m(LoadingIndicator, {
                                        colorScheme: "secondary"
                                    }) 
                                )
                            )
                        ])

                        : 
                        m("div.p-5", 
                            m(LoadingIndicator, {
                                colorScheme: "secondary"
                            }) 
                        ),
                        
                        m(LightBox, {
                            imageUrls: (hotelPhotoDialogState != 'hidden')? 
                                (hotelPhotoDialogState as HotelPhotoDialogShown).photoUrls : [],
                            show: hotelPhotoDialogState != 'hidden',
                            onClose: () => {
                                hotelPhotoDialogState = 'hidden';
                            }
                        })
                    ])                    
                ),
                m("button.btn btn-primary rounded-circle py-3", {id:"scrollToTop"}, m("i.bi bi-arrow-up"))
            ]);
        }
    }
}


export default HotelSearchPage;

